import {createRouter, createWebHistory} from 'vue-router'
const router = createRouter({
  history: createWebHistory(),
  routes: [{
    path: '/', redirect: '/home'
  },{
    path: '/home',
    component: () => import('./pages/home.vue')
  }, {
    path: '/subMain/:pathMatch(.*)*',
    name: 'subMain',
    component: () => import('./pages/subMain.vue')
  }]
})
export default router